class UsersWrapperDirective {
  static directive() {
    return {
      transclude: true,
      scope: {
        pageClass: '@'
      },
      template: `
        <div layout="row" layout-fill layout-align="start stretch"  class="{{ pageClass }}">
          <div class="image-box">

          </div>
          <div class="content-container">
            <ng-transclude></ng-transclude>
          </div>
        </div>
      `
    }
  };
}

export default UsersWrapperDirective.directive;



// WEBPACK FOOTER //
// ./src/users/directives/users-wrapper.js